export const typeTable = function () {
  return {
    index: true,
    indexLabel: "序号",
    highlightCurrentRow: true,
    maxHeight: "100%",
    column: [
      {
        label: "类型",
        prop: "personnelMarkName",
        search: false,
        clearable: true
      }
    ]
  };
};
